import { useCallback, useState } from 'react';
import fleetApi from '../../services/api.service';

const toError = (err, fallback) =>
  new Error(err?.response?.data?.message || err.message || fallback);

/**
 * Modification et archivage d'un entrepôt (PUT /factories/:id,
 * POST /factories/:id/archive). L'archivage est refusé par l'API tant que des
 * véhicules actifs y sont rattachés : le message les liste.
 */
const useWarehouseActions = () => {
  const [isSaving, setIsSaving] = useState(false);

  const updateWarehouse = useCallback(async (factoryId, data) => {
    setIsSaving(true);
    try {
      const response = await fleetApi.put(`/factories/${factoryId}`, data);
      return response.data?.data;
    } catch (err) {
      throw toError(err, "Impossible de modifier l'entrepôt");
    } finally {
      setIsSaving(false);
    }
  }, []);

  const archiveWarehouse = useCallback(async (factoryId) => {
    setIsSaving(true);
    try {
      await fleetApi.post(`/factories/${factoryId}/archive`);
    } catch (err) {
      throw toError(err, "Impossible d'archiver l'entrepôt");
    } finally {
      setIsSaving(false);
    }
  }, []);

  return { updateWarehouse, archiveWarehouse, isSaving };
};

export default useWarehouseActions;
